import { MapComment } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    addEntitySocket,
    deleteEntitySocket,
    updateEntitySocket,
} from "features/entity-caching/project/slice"
import { v4 as randomUUID } from "uuid"
import {
    CreateCommentArgs,
    getDefaultCommentCreateArgs,
    UpdateCommentArgs,
} from "@nova/serializer/src/client/validators"
import { selectUserID } from "user/profile/selectors"

const {
    create: createMapComment,
    update: updateMapComment,
    delete: deleteMapComment,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    MapComment,
    CreateCommentArgs,
    ["longitude", "latitude"],
    UpdateCommentArgs,
    { id?: string }
>("MapComment")

export const addMapCommentsToBuilder = (builder: Builder) =>
    builder
        .addCase(createAction, (store, { payload: { data, context = {} } }, socket) => {
            const state = store.getState()
            const userId = selectUserID(state)!
            const optimisticData = {
                id: context.id ?? randomUUID(),
                ...getDefaultCommentCreateArgs(),
                ...data,
                createdBy: { userId },
            }
            createMapComment(socket, { ...data, id: optimisticData.id, createdBy: { userId } }, {})
            store.dispatch(
                addEntitySocket({
                    data: optimisticData,
                    path: ["mapComments"],
                })
            )
        })
        .addCase(updateAction, (store, { payload: { id, updates } }, socket) => {
            updateMapComment(socket, id, updates, {})
            store.dispatch(updateEntitySocket({ id, updates, path: ["mapComments", { id }] }))
        })
        .addCase(deleteAction, (store, { payload: { id } }, socket) => {
            deleteMapComment(socket, id, {})
            store.dispatch(deleteEntitySocket({ path: ["mapComments", { id }] }))
        })

export {
    createAction as createMapComment,
    updateAction as updateMapComment,
    deleteAction as deleteMapComment,
}
